class ShippingGoalBar extends HTMLElement {
  connectedCallback() {
    document.addEventListener('cart:updated', (e) => {
      this.update(e.detail.cart.total_price);
    });

    document.addEventListener('product-ajax:added', (e) => {
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => this.update(cart.total_price));
    });
  }

  update(cartTotalCents) {
    const threshold = parseFloat(this.dataset.threshold);
    const remaining = Math.max(0, threshold - cartTotalCents);
    const progress = Math.min(100, Math.round((cartTotalCents / threshold) * 100));

    this.querySelector('.shipping-goal__fill').style.setProperty('--progress', `${progress}%`);
    this.querySelector('.shipping-goal__fill').setAttribute('aria-valuenow', progress);

    const title = this.querySelector('.shipping-goal__title');
    const meta = this.querySelector('.shipping-goal__meta span');

    const cartDisplay = (cartTotalCents / 100).toFixed(2);
    const thresholdDisplay = (threshold / 100).toFixed(2);
    const remainingDisplay = (remaining / 100).toFixed(2);

    if (remaining <= 0) {
      title.innerHTML = '🎉 Beneficiezi de <strong>transport GRATUIT!</strong>';
      title.style.color = '#0a7c50';
    } else {
      title.innerHTML = `Adaugă <strong>${remainingDisplay} lei</strong> pentru <strong>transport gratuit!</strong>`;
      title.style.color = '';
    }

    if (meta) {
      meta.textContent = `${cartDisplay} lei / ${thresholdDisplay} lei`;
    }
  }
}

customElements.define('shipping-goal-bar', ShippingGoalBar);